import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TariffDto } from 'src/app/shared/models';
import { NumberWithSpacesPipe } from 'src/app/modules/platform/pipes/number-with-spaces.pipe';
import { DiscountDisplayPipe } from '../../pipes/discount-display.pipe';

@Component({
  selector: 'app-billing-total-card',
  templateUrl: './billing-total-card.component.html',
  styleUrls: ['./billing-total-card.component.scss'],
  imports: [CommonModule, TranslateModule, NumberWithSpacesPipe, DiscountDisplayPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BillingTotalCardComponent {
  constructor() {}

  @Input() tariff: TariffDto;
}
